import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueRouter from "vue-router";

// Éviter les erreurs "NavigationDuplicated" et "Redirected" non capturées de Vue Router 3
const originalPush = VueRouter.prototype.push as any;
VueRouter.prototype.push = function push(location: any) {
    return originalPush.call(this, location).catch((err: any) => {
        if (err && err.name !== 'NavigationDuplicated' && !err.message?.includes('Redirected')) {
            throw err;
        }
    });
};

import BootstrapVue from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import device from "vue-device-detector-js";
// import './assets/css/style.bundle.css'
import {auth} from "@/services/Auth";
import {trans} from "@/services/Translator";
import {helper} from "@/services/Helper";
import {errorLogger} from "@/services/ErrorLogger";
import JsonViewer from "vue-json-viewer";
import "vue-json-viewer/style.css";

import VueApexCharts from "vue-apexcharts";
import ResponseGroupManager from "@/views/Comparator/Components/ResponseGroupManager.vue";
import Partner from "@/entity/Partner";
// import FormProcessor from "@/views/Income/Comparator/FormProcessor.vue";
// import {TitleMixin} from './Mixin/TitleMixin'
// @ts-ignore
import VueTree from "@ssthouse/vue-tree-chart";
import "sweetalert2/dist/sweetalert2.min.css";
// Charte mobile WiASSUR : jetons + classes .wm-* partagees par les ecrans mobiles.
import "@/assets/css/wia-mobile.css";

import JsonExcel from "vue-json-excel";

import VueCryptojs from "vue-cryptojs";
import MultipleSurvey from "@/views/Income/Comparator/FormComponents/MultipleSurvey.vue";
// @ts-ignore
import Paginate from "vuejs-paginate";
import RoleLine from "@/views/Role/RoleLine.vue";
// Vue.mixin(TitleMixin)
import Draggable from "vuedraggable";
import Popup from "@/entity/Popup";
import CONSTANTS, {WORKFLOWS} from "@/Utils/constant";
// import draggable from 'vuedraggable';
import {api} from "@/services/Api";
import User from "./entity/User";
import {USE_LOCAL_MENU} from "@/router/Menu";
import localMenu from "@/router/menu.local.json";
import ItemTree from "@/components/ItemTree.vue";
import Tenant from "@/entity/Tenant";
import AvenantTypePropertyEditor from "@/views/Configuration/AvenantType/AvenantTypePropertyEditor.vue";
import ItemTypeTree from "./components/ItemTypeTree.vue";
import AvenantItemTree from "@/views/Income/Avenant/AvenantItemTree.vue";
import AvenantObjectGroupManager from "@/views/Income/Avenant/Components/AvenantObjectGroupManager.vue";
// @ts-ignore
import VueVirtualScroller from "vue-virtual-scroller";
import {engineService} from "@/services/calculator/EngineService";
import {CleanupMixin} from "@/Mixin/cleanup-mixin";

Vue.mixin(CleanupMixin);

// import firebaseMessaging from './services/Firebase'

Vue.use(BootstrapVue);
Vue.use(device);
// import FormProcessor from "@/views/Income/Comparator/FormProcessor.vue";
Vue.config.productionTip = false;

Vue.use(JsonViewer);
Vue.use(VueVirtualScroller);
Vue.use(VueCryptojs);

Vue.component("MultipleSurvey", MultipleSurvey);
Vue.component("ResponseGroupManager", ResponseGroupManager);
Vue.component("downloadExcel", JsonExcel);
Vue.component("vue-tree", VueTree);
Vue.component(
    "FormProcessor",
    require("./views/Income/Comparator/FormProcessor.vue").default
);
Vue.component(
    "ItemManager",
    require("./views/Income/Avenant/ItemManager").default
);

Vue.component(
    "ItemViewer",
    require("./views/Income/Contract/ItemViewer.vue").default
);

Vue.component(
    "ComparisonOfferDetailLine",
    require("./views/Comparator/Components/ComparisonOfferDetailLine").default
);
Vue.component(
    "PropertyManager",
    require("./views/Income/Avenant/PropertyManager").default
);
Vue.component(
    "AvenantDetail",
    require("./views/Contract/AvenantDetail").default
);
Vue.component(
    "IncorporationDetail",
    require("./views/Contract/IncorporationDetail").default
);
Vue.component(
    "EngineLineEditor",
    require("./views/Engine/EngineLineEditor").default
);
Vue.component(
    "ItemTypeInspector",
    require("./views/Engine/ItemTypeInspector").default
);
Vue.component(
    "ItemTypeClickInspector",
    require("./views/Engine/ItemTypeClickInspector").default
);
Vue.component(
    "ItemLine",
    require("./views/Configuration/Branch/Mapper/ItemLine").default
);
Vue.component(
    "AddRemoveItemLine",
    require("./views/Income/Avenant/AvenantManager/AddRemoveItemLine.vue").default
);
Vue.component(
    "AddRemovePropertyLine",
    require("./views/Income/Avenant/AvenantManager/AddRemovePropertyLine.vue")
        .default
);

Vue.component("paginate", Paginate);

Vue.component("RoleLine", RoleLine);

Vue.component("ItemTree", ItemTree);
Vue.component("ItemTypeTree", ItemTypeTree);
Vue.component("AvenantTypePropertyEditor", AvenantTypePropertyEditor);

// Vue.component("AvenantItemTree", require("./views/Income/Avenant/AvenantItemTree.vue").default);
Vue.component("AvenantItemTree", AvenantItemTree);
Vue.component("AvenantObjectGroupManager", AvenantObjectGroupManager);

Vue.component("draggable", Draggable);

Vue.directive("uppercase", {
    update: function (el: any) {
        el.value = el.value.toUpperCase();
    },
});

Vue.use(VueApexCharts);

// Vue.use(ClassicEditor)

Vue.component("apexchart", VueApexCharts);

// Plus besoin de publicRoutes — les routes sans meta.requiredRoles sont publiques
const _legacyPublicRoutes = [
];

function isDebug(): boolean {
    try {
        return localStorage.getItem('debug') === 'true';
    } catch {
        return false;
    }
}

function debugLog(...args: any[]) {
    if (isDebug()) {
        console.log('%c[Router Guard]', 'color: #e67e22; font-weight: bold;', ...args);
    }
}

function debugWarn(...args: any[]) {
    if (isDebug()) {
        console.warn('%c[Router Guard]', 'color: #e74c3c; font-weight: bold;', ...args);
    }
}

// Évalue les restrictions partner (submenu + routes) contre les menus en mémoire.
// Retourne null si OK, sinon {label, message} décrivant le refus.
function evaluatePartnerRestrictions(to: any): { label: string, message: string } | null {
    if (!auth.hasRole("ROLE_PARTNER")) return null;
    const settings = store.state.settings;
    if (!settings) return null;
    const menus = store.state.mainStore.menus;
    if (settings.submenu && settings.submenu.length > 0) {
        const parentMenu = menus.find((m: any) =>
            m.subMenus && m.subMenus.some((sub: any) => settings.submenu.includes(sub.path))
            && m.subMenus.some((sub: any) => sub.name === to.name || sub.path === to.path)
        );
        if (parentMenu && !settings.submenu.includes(to.path)) {
            return {label: 'SUBMENU_RESTRICTED', message: "Votre gestionnaire n'a pas autorisé l'accès à cette page"};
        }
    }
    if (settings.routes && settings.routes.length > 0) {
        const parentMenu = menus.find((m: any) =>
            m.subMenus && m.subMenus.some((sub: any) => sub.name === to.name || sub.path === to.path)
        );
        if (parentMenu && !settings.routes.includes(parentMenu.path)) {
            return {label: 'ROUTE_PARENT_RESTRICTED', message: "Votre gestionnaire n'a pas autorisé l'accès à ce module"};
        }
    }
    return null;
}

// Flag pour ne rafraîchir le menu qu'une seule fois par navigation (en cas de refus).
let menuRefreshedForNav: string | null = null;

async function refreshMenusFromAuth(): Promise<void> {
    if (USE_LOCAL_MENU) return; // menu local force : on n'ecrase pas avec le serveur
    try {
        const res = await api.get(api.auth, 'menu/list');
        if (res?.data?.menu) {
            store.state.mainStore.menus = res.data.menu;
            localStorage.setItem('menus', JSON.stringify(res.data.menu));
        }
    } catch (_) { /* silent */ }
}

async function refreshPartnerSettings(): Promise<void> {
    if (!auth.hasRole('ROLE_PARTNER')) return;
    try {
        const res = await api.get(api.auth, 'auth/partner/settings/refresh');
        if (res?.data?.settings !== undefined) {
            store.state.settings = res.data.settings;
            localStorage.setItem('settings', JSON.stringify(res.data.settings));
        }
    } catch (_) { /* silent */ }
}

router.beforeEach(async (to, from, next) => {
    debugLog(`Navigation: "${from.name}" → "${to.name}" (path: ${to.path})`);

    const requiredRoles: string[] | undefined = to.meta?.requiredRoles;

    if (!requiredRoles || requiredRoles.length === 0) {
        next();
        return;
    }

    if (!auth.isConnected()) {
        next({name: 'login'});
        return;
    }

    const currentTenant: Tenant = store.state.mainStore.currentTenant;
    if (!currentTenant && to.name !== 'tenant-selector') {
        next({name: 'tenant-selector'});
        return;
    }

    if (auth.isAdmin()) {
        next();
        return;
    }

    // Helper : refuse avec log unique + redirection.
    const deny = (requiredLabels: string[], msg: string) => {
        errorLogger.logRouteDenied(to.path, (to.name as string) ?? null, requiredLabels, auth.getRoles(), msg);
        next({name: 'access-denied', query: {message: msg, targetName: (to.name as string) ?? '', targetPath: to.fullPath ?? ''}});
    };

    // Évaluation initiale.
    const hasRole = requiredRoles.some((role: string) => auth.hasRole(role));
    let partnerDenial = hasRole ? evaluatePartnerRestrictions(to) : null;

    if (hasRole && !partnerDenial) {
        next();
        return;
    }

    // Refus détecté : on rafraîchit menu + settings partner une fois, puis on ré-évalue.
    const navKey = (to.fullPath || '') + '|' + (to.name as string || '');
    if (menuRefreshedForNav !== navKey) {
        menuRefreshedForNav = navKey;
        await Promise.all([refreshMenusFromAuth(), refreshPartnerSettings()]);
        // Rééval partner restrictions (les rôles JWT ne changent pas sans reconnexion).
        if (hasRole) {
            partnerDenial = evaluatePartnerRestrictions(to);
            if (!partnerDenial) {
                next();
                return;
            }
        }
    }

    if (!hasRole) {
        deny(requiredRoles, "Vous n'avez pas accès à la page " + to.name);
        return;
    }
    if (partnerDenial) {
        deny([partnerDenial.label], partnerDenial.message);
        return;
    }

    next();
});


// Vue.prototype.$messaging = firebaseMessaging

Vue.prototype.trans = (code: string) => {
    return trans.translate(code);
};

Vue.prototype.hasRole = (role: string) => {
    return auth.hasRole(role);
};
Vue.prototype.hasRoles = (roles: []) => {
    return auth.hasRoles(roles);
};
// Vue.prototype.getManagerIdentifier = async () => {
//     await api.getManagerIdentifier
// }
Vue.prototype.loading = (
    title = "",
    message: string,
    type = "secondary",
    icon = "fad fa-exclamation",
    keepAlive = false,
    link?: string,
    buttons?: []
) => {
    return new Popup(title, message, type, icon, keepAlive, link, buttons);
};

const getCircularReplacer = () => {
    const seen = new WeakSet();
    const disallowed = [
        "createdAt",
        "updatedAt",
        "createBy",
        "updateBy",
        "removeBy",
        "createdFromIp",
        "updatedFromIp",
    ];
    return (key: any, value: any) => {
        if (disallowed.includes(key)) {
            return;
        }
        if (typeof value === "object" && value !== null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    };
};
Vue.prototype.stringify = (obj: any) => {
    return JSON.stringify(obj, getCircularReplacer());
};

Vue.prototype.readableDate = helper.readable;
Vue.prototype.readable = helper.readable;
Vue.prototype.dateToHtml = helper.dateToHtml;
Vue.prototype.reversedDateToHtml = helper.reversedDateToHtml;
Vue.prototype.datify = helper.readable;
Vue.prototype.currency = helper.currencyFormat;
Vue.prototype.miniCurrency = helper.minifyCurrency;
Vue.prototype.roundMoney = helper.roundMoney;
Vue.prototype.numberFormat = helper.numberFormat;
Vue.prototype.phoneFormat = helper.phoneFormat;
Vue.prototype.phonify = helper.phoneFormat;

Vue.prototype.abs = Math.abs;
Vue.prototype.timelapse = helper.getTimeLapse;
Vue.prototype.smartlapse = (date: Date) => {
    return helper.getSmartLapse(date);
};
Vue.prototype.CONSTANTS = CONSTANTS;
Vue.prototype.WORKFLOWS = WORKFLOWS;
Vue.prototype.genId = helper.generateId;
Vue.prototype.helper = helper;
Vue.prototype.hasRole = (role: string) => {
    return auth.hasRole(role);
};
Vue.prototype.userHasRole = (user: User, role: string) =>
    auth.userHasRole(user, role);
Vue.prototype.partnerHasRole = (partner: Partner, role: string) =>
    auth.partnerHasRole(partner, role);
Vue.prototype.checkRoleTabs = (roles: any[]) => auth.checkRoleTabs(roles);
Vue.prototype.getManagerIdentifier = (uuid: string) => {
    return api.getManagerIdentifier(uuid);
};

Vue.filter("round", Math.round);
Vue.prototype.empty = helper.empty;
Vue.prototype.isMobile = () => {
    let check = false;
    (function (a) {
        if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                a
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                a.substr(0, 4)
            )
        )
            check = true;
    })(navigator.userAgent || navigator.vendor || (window as any).opera);
    return check;
};


window.addEventListener('beforeunload', () => {
    // console.log('[Window] beforeunload - shutdown engine');
    engineService.shutdown();
});

// Sentry error tracking — npm install @sentry/vue@7 pour activer
try {
    if (process.env.VUE_APP_SENTRY_DSN) {
        const Sentry = require('@sentry/vue');
        Sentry.init({
            Vue,
            dsn: process.env.VUE_APP_SENTRY_DSN,
            tracesSampleRate: 0.2,
            environment: process.env.NODE_ENV,
        });
    }
} catch (e) {
    // @sentry/vue non installé — ignorer
}

// Global error handlers — envoie les erreurs JS vers le backend
Vue.config.errorHandler = (err: Error, _vm: any, info: string) => {
    errorLogger.logJsError(err, `Vue[${info}]`);
};

window.addEventListener('error', (event: ErrorEvent) => {
    errorLogger.logJsError(event.error ?? event.message, event.filename ?? 'window.onerror');
});

window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    const reason = event.reason;
    if (reason instanceof Error) {
        errorLogger.logJsError(reason, 'unhandledrejection');
    } else if (reason && typeof reason === 'object' && reason.message) {
        errorLogger.logJsError(reason.message, 'unhandledrejection');
    }
});

// Menu local force (VUE_APP_USE_LOCAL_MENU) : on purge le cache serveur et on
// installe le menu front (src/router/menu.local.json, copie fidele du menu serveur
// avec ses roles) comme source AVANT le 1er rendu. Editer ce JSON = menu a jour
// sans toucher au serveur auth.
if (USE_LOCAL_MENU) {
    localStorage.removeItem('menus');
    store.state.mainStore.menus = localMenu as any;
}

new Vue({
    router,
    store,
    render: (h) => h(App as any),
}).$mount("#app");
if ((module as any).hot) {
    (module as any).hot.accept();

    (module as any).hot.dispose(() => {
        // console.log('[HMR] Dispose - shutdown engine');
        engineService.shutdown();
    });
}